/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{neverReached as e}from"../../../../../../core/compilerUtils.js";import{FloatDrawUniform as t}from"../../../core/shaderModules/FloatDrawUniform.js";import{glsl as r}from"../../../core/shaderModules/interfaces.js";import{EdgeType as s}from"./EdgeUtil.glsl.js";import{UnpackAttributes as a}from"./UnpackAttributes.glsl.js";function d(d,i){const o=d.vertex;switch(d.include(a,i),i.type){case s.Solid:o.code.add(r`float calculateLineAmplitude(UnpackedAttributes unpackedAttributes) {
return 0.0;
}`);break;case s.Sketch:o.uniforms.add(new t("strokesAmplitude",(e=>e.strokesTexture.amplitude))),o.code.add(r`float calculateLineAmplitude(UnpackedAttributes unpackedAttributes) {
return strokesAmplitude;
}`);break;case s.Mixed:o.uniforms.add(new t("strokesAmplitude",(e=>e.strokesTexture.amplitude))),o.code.add(r`float calculateLineAmplitude(UnpackedAttributes unpackedAttributes) {
float type = unpackedAttributes.type;
if (type <= 0.0) {
return strokesAmplitude;
}
return 0.0;
}`);break;case s.COUNT:break;default:e(i.type)}}export{d as LineAmplitude};
